import React from "react";
import {useNavigate} from "react-router-dom";
import {AuthEventType, createAuthenticationContext} from "./AuthenticationContext";

interface AuthenticationContextProps {
  children: React.ReactElement;
}

export const AuthenticationContextProvider = ({ children }: AuthenticationContextProps) => {
  const navigate = useNavigate()
  createAuthenticationContext((eventType: AuthEventType, data?: string) => {
    if (eventType === AuthEventType.RESTORE_STATE && data) {
      navigate(data);
    }
  })

  return children;
}